import { SET_OFFLINE_STATUS } from './actionTypes';

export const initialActionsState = {
  setOfflineStatus: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  setOfflineStatus: (status: boolean) => {
    dispatch({
      type: SET_OFFLINE_STATUS,
      payload: status,
    });
  },
});
